export const PACIFIC_TIME_ZONE = "America/Los_Angeles";
export const QUESTION_TIMER_MS = 10_000;
export const MULTIPLE_CHOICE_TIMER_MS = 10_000;
export const TEXT_INPUT_TIMER_MS = 15_000;

export function questionTimerMs(answerType?: "multipleChoice" | "textInput"): number {
  return answerType === "textInput" ? TEXT_INPUT_TIMER_MS : MULTIPLE_CHOICE_TIMER_MS;
}

export function isoNow(date = new Date()): string {
  return date.toISOString();
}

export function addMs(isoDate: string, ms: number): string {
  return new Date(new Date(isoDate).getTime() + ms).toISOString();
}

export function isExpired(deadlineIso: string, now = new Date()): boolean {
  return new Date(deadlineIso).getTime() <= now.getTime();
}

export function responseMs(startedAt: string, submittedAt: string): number {
  return Math.max(0, new Date(submittedAt).getTime() - new Date(startedAt).getTime());
}

export function getPacificParts(date = new Date()): Record<string, number> {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: PACIFIC_TIME_ZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    weekday: "short",
    hour12: false
  }).formatToParts(date);

  const values: Record<string, number> = {};
  for (const part of parts) {
    if (part.type !== "literal" && part.type !== "weekday") {
      values[part.type] = Number(part.value);
    }
  }
  return values;
}

function zonedTimeToUtc(year: number, month: number, day: number, hour: number, minute: number, second: number): Date {
  const utcGuess = new Date(Date.UTC(year, month - 1, day, hour, minute, second));
  const pacificParts = getPacificParts(utcGuess);
  const asPacificUtc = Date.UTC(
    pacificParts.year,
    pacificParts.month - 1,
    pacificParts.day,
    pacificParts.hour === 24 ? 0 : pacificParts.hour,
    pacificParts.minute,
    pacificParts.second
  );
  const targetUtc = Date.UTC(year, month - 1, day, hour, minute, second);
  return new Date(utcGuess.getTime() + (targetUtc - asPacificUtc));
}

export function currentPacificWeek(date = new Date()): { startAt: string; endAt: string } {
  const pacific = new Date(date.toLocaleString("en-US", { timeZone: PACIFIC_TIME_ZONE }));
  const day = pacific.getDay();
  const mondayOffset = day === 0 ? -6 : 1 - day;
  const monday = new Date(pacific);
  monday.setDate(pacific.getDate() + mondayOffset);
  monday.setHours(0, 0, 0, 0);

  const start = zonedTimeToUtc(monday.getFullYear(), monday.getMonth() + 1, monday.getDate(), 0, 0, 0);
  const nextMonday = new Date(monday);
  nextMonday.setDate(monday.getDate() + 7);
  const end = zonedTimeToUtc(nextMonday.getFullYear(), nextMonday.getMonth() + 1, nextMonday.getDate(), 0, 0, 0);
  return { startAt: start.toISOString(), endAt: end.toISOString() };
}

export function unlockAtForDay(weekStartIso: string, dayOfWeek: number): string {
  return new Date(new Date(weekStartIso).getTime() + (dayOfWeek - 1) * 24 * 60 * 60 * 1000).toISOString();
}

export function dayLabel(dayOfWeek: number): string {
  return ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"][dayOfWeek - 1] ?? "Day";
}
